export const data = {
  buttons: [
    {
      label: 'Yes',
      id: 'yes',
    },
    {
      label: 'No',
      id: 'no',
    },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/41c82207eb70-tooliconsuitcase.jpg',
  },
  title: 'Have you already been on holiday?',
}
